import { Modal, useTranslation, useNextgenRouter } from '@nextgen-web-framework/all';
import { useSelector, useDispatch } from 'react-redux';
import type { AppState, AppDispatch } from '@nextgen-web-framework/core';
import { identityApi } from '@commerce-identity-webcomponents/sdk';
import { updateRegistrationData } from '@commerce-profile-webcomponents/sdk';
import { isEmail } from '../../utils/helper';
import { useGlobalErrorHandler } from '../../utils/globalErrorHook';
import { RegistrationSignInModalProps } from './types/propTypes';
import styles from './RegistrationSignInModal.module.scss';

const RegistrationSignInModal = ({ defaultLoginIdentityProps }: RegistrationSignInModalProps) => {
  const { push } = useNextgenRouter();
  const apiErrorHandler = useGlobalErrorHandler();

  const t = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const registrationFlowData = useSelector((state: AppState) => state.commerceProfile.registrationFlowData);
  const { userName } = registrationFlowData.signupFormData;
  const isUsernameEmail = isEmail(userName);
  const onPrimaryButtonClick = async (event: React.KeyboardEvent | React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    const url = await apiErrorHandler(() =>
      identityApi.getAuthorizeUrl({
        ...defaultLoginIdentityProps,
      }),
    );
    push && push(url);
  };
  const onSecondaryButtonClick = () => {
    dispatch(
      updateRegistrationData({
        ...registrationFlowData,
        signupFormData: {
          ...registrationFlowData.signupFormData,
          userName: '',
          dialCode: '',
        },
        isDuplicateUser: false,
      }),
    );
  };
  const headline = isUsernameEmail
    ? t('profile.RegistrationSignInModal.headlineEmail')
    : t('profile.RegistrationSignInModal.headlineMobile');
  const ModalText = isUsernameEmail
    ? t('profile.RegistrationSignInModal.modalTextEmail')
    : t('profile.RegistrationSignInModal.modalTextMobile');
  const secondaryButtonLabel = isUsernameEmail
    ? t('profile.RegistrationSignInModal.secondaryButtonEmail')
    : t('profile.RegistrationSignInModal.secondaryButtonMobile');
  return (
    <div className={styles['RegistrationSignInModal-modal']} data-testid="RegistrationSignInModal-modal">
      <Modal
        headline={headline}
        primaryButtonLabel={t('profile.common.signInButton')}
        secondaryButtonLabel={secondaryButtonLabel}
        onPrimaryButtonClick={onPrimaryButtonClick}
        onSecondaryButtonClick={onSecondaryButtonClick}
        onClose={onSecondaryButtonClick}
      >
        <span data-testid="RegistrationSignInModal-test-id">{ModalText}</span>
      </Modal>
    </div>
  );
};

export default RegistrationSignInModal;
